// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import globalData from "./global/globalData";
import axios from "axios";
import ajax from "./api/ajax";
import "./global/flexible";

// import "../static/flexible"

Vue.prototype.https = ajax;
// import jquery from "jquery";
// import $ from "jquery";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import { sha256 } from "js-sha256";
Vue.prototype.$sha256 = sha256;

import "../static/jquery_flexslider";

import Base64 from "./global/base64";
Vue.prototype.$Base64 = Base64;

import AMap from "vue-amap";
Vue.use(AMap);

// 初始化vue-amap
AMap.initAMapApiLoader({
  // 高德key
  key: "f70bc5c7054ad7ff99238315ae029f1b",
  // 插件集合 （插件按需引入）
  plugin: [
    "AMap.Scale",
    "AMap.OverView",
    "AMap.ToolBar",
    "AMap.MapType",
    "AMap.PlaceSearch",
    "AMap.Geolocation"
  ],
  v: "1.4.4",
  uiVersion: "1.0.11"
});

import Video from "video.js";
import "video.js/dist/video-js.css";
Vue.prototype.$video = Video;

Vue.use(ElementUI);

Vue.config.productionTip = false;
Vue.prototype.globalData = globalData;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  render: h => h(App)
  // components: { App },
  // template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js